module.exports = __webpack_public_path__ + "static/media/2.b916289f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/2.svg
// module id = 2811
// module chunks = 3